import { render, staticRenderFns } from "./linkPreview.vue?vue&type=template&id=e453cab2&scoped=true"
import script from "./linkPreview.vue?vue&type=script&lang=ts"
export * from "./linkPreview.vue?vue&type=script&lang=ts"
import style0 from "./linkPreview.vue?vue&type=style&index=0&id=e453cab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453cab2",
  null
  
)

export default component.exports